 export default class Template {
	constructor(template_id){
		this.template_id = template_id;
		this.tpl = document.getElementById(template_id).innerHTML;
	}

	fill(data){
		let matches = this.tpl.matchAll(/\[\[([^\[\]]*?)\]\]/g),
			filled = this.tpl;

		for(let match of matches){
			let prop = match[1];
			let val = this.data_get(data, prop);
				val = val != null && val != undefined ? val : '';
			filled = filled.replaceAll(`[[${prop}]]`, `${val}`);
		}

		return filled.trim();
	}

	static from(id, data){
		let tpl = new Template(id);
		return tpl.fill(data);
	}
	data_get(obj, str) {
		let props = str.split('.'),
			result = obj;
		for(let prop of props) result = result[prop];
		return result;
	}
}